module.exports = __webpack_public_path__ + "7aac420f.svg";